import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, Calculator } from 'lucide-react';
import { Button } from './ui/Button';
import { useLang } from '../contexts/LanguageContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useLang();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t('nav_about'),
    href: '#about'
  }, {
    name: t('nav_services'),
    href: '#services'
  }, {
    name: t('nav_advantages'),
    href: '#why-us'
  }, {
    name: t('nav_faq'),
    href: '#faq'
  }, {
    name: t('nav_contacts'),
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'border-b border-neutral-100 py-4' : 'py-6'}`} data-id="element-190">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl" data-id="element-191">
        <div className="flex items-center justify-between" data-id="element-192">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-193">
            <div className="p-1.5 border border-black rounded-none" data-id="element-194">
              <Calculator className="h-5 w-5 text-black" data-id="element-195" />
            </div>
            <span className="font-bold text-lg leading-none text-black tracking-tight" data-id="element-196">
              Бухгалтер
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-197">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-neutral-500 hover:text-black transition-colors" data-id="element-198">
                {link.name}
              </a>)}
          </nav>

          {/* Right side: lang switcher + phone + CTA */}
          <div className="flex items-center gap-4 md:gap-6" data-id="element-199">
            {/* Language switcher */}
            <div className="hidden md:flex items-center gap-1 text-sm" data-id="element-200">
              <button onClick={() => setLang('ua')} className={`transition-colors ${lang === 'ua' ? 'font-bold text-black' : 'text-neutral-400 hover:text-neutral-600'}`} data-id="element-201">
                UA
              </button>
              <span className="text-neutral-300" data-id="element-202">/</span>
              <button onClick={() => setLang('ru')} className={`transition-colors ${lang === 'ru' ? 'font-bold text-black' : 'text-neutral-400 hover:text-neutral-600'}`} data-id="element-203">
                RU
              </button>
            </div>

            <a href="tel:+380500000000" className="hidden md:flex items-center gap-2 font-medium text-black hover:text-neutral-600 transition-colors group" data-id="element-204">
              <Phone className="h-4 w-4 group-hover:animate-pulse" data-id="element-205" />
              <span className="text-sm" data-id="element-206">+380 50 000 00 00</span>
            </a>
            <Button variant="primary" size="sm" className="hidden md:inline-flex" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-207">
              {t('nav_consultation')}
            </Button>

            <button className="md:hidden p-2 text-black" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-208">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-209" /> : <Menu className="h-6 w-6" data-id="element-210" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white border-b border-neutral-100 p-6 md:hidden flex flex-col gap-4 animate-in slide-in-from-top-2" data-id="element-211">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-black font-medium py-3 border-b border-neutral-100 last:border-0" onClick={() => setIsMobileMenuOpen(false)} data-id="element-212">
              {link.name}
            </a>)}
          <div className="pt-4 flex flex-col gap-3" data-id="element-213">
            {/* Mobile lang switcher */}
            <div className="flex items-center gap-2 text-sm py-2" data-id="element-214">
              <button onClick={() => setLang('ua')} className={`transition-colors ${lang === 'ua' ? 'font-bold text-black' : 'text-neutral-400'}`} data-id="element-215">
                UA
              </button>
              <span className="text-neutral-300" data-id="element-216">/</span>
              <button onClick={() => setLang('ru')} className={`transition-colors ${lang === 'ru' ? 'font-bold text-black' : 'text-neutral-400'}`} data-id="element-217">
                RU
              </button>
            </div>
            <a href="tel:+380500000000" className="flex items-center justify-center gap-2 font-medium text-black py-2" data-id="element-218">
              <Phone className="h-4 w-4" data-id="element-219" />
              +380 50 000 00 00
            </a>
            <Button className="w-full" onClick={() => {
          setIsMobileMenuOpen(false);
          document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-220">
              {t('nav_order_consultation')}
            </Button>
          </div>
        </div>}
    </header>;
}